module.exports = __webpack_public_path__ + "static/uvic.7fd7dd8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/highered_logos/uvic.png
// module id = 2211
// module chunks = 61762850755587